module.exports = __webpack_public_path__ + "static/media/comments-icon.80240bfc.svg";